module.exports = __webpack_public_path__ + "img/23.4ab8ed62.png";